import React from 'react';
import { LinkedinIcon, YoutubeIcon } from 'lucide-react';
import { contact, navLinks, socialLinks } from '../../data/site';
import { EnergyTrace } from '../ui/EnergyTrace';
import { SupplyTag } from '../ui/SupplyTag';
export function Footer() {
  return <footer className="bg-afb-light pb-24 md:pb-0" data-id="element-115" data-mp="ao9yrt5e7ziy">
      <EnergyTrace data-id="element-116" data-mp="5nvn814l27g6" />
      <div className="mx-auto grid max-w-page gap-12 px-5 py-16 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr] lg:px-8" data-id="element-117" data-mp="5maw6lhh96n2">
        <div data-id="element-118" data-mp="q2ilcixhli0">
          <img src={contact.logo} alt="Australian Flow Batteries" className="h-10 w-auto" data-id="element-119" data-mp="pu3ddzc243n" />
          <p className="mt-5 max-w-xs text-[15px] leading-relaxed text-afb-muted" data-id="element-120" data-mp="3s0u88bizc9qd">
            Containerised power systems for remote and critical operations. Perth-based, Australia-wide.
          </p>
          <div className="mt-5 flex items-center gap-2 text-sm text-afb-muted" data-id="element-121" data-mp="3j05ttfpoc7cy">
            ABN <SupplyTag label="ABN supplied" data-id="element-122" data-mp="3e4yuek3ftotu" />
          </div>
        </div>

        <div data-id="element-123" data-mp="39542qebu8v7q">
          <h2 className="font-sora text-sm font-semibold text-afb-ink" data-id="element-124" data-mp="394kw3trn1t90">Explore</h2>
          <ul className="mt-4 space-y-3 text-[15px]" data-id="element-125" data-mp="2kcbenoreeks2">
            {navLinks.map(link => <li key={link.label} data-id="element-126" data-mp="2p4mpvnrl9szx">
                <a href={link.href} className="text-afb-muted transition-colors duration-150 hover:text-afb-ink" data-id="element-127" data-mp="2p5o0xs8lufhn">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </div>

        <div data-id="element-128" data-mp="341dgb7jabude">
          <h2 className="font-sora text-sm font-semibold text-afb-ink" data-id="element-129" data-mp="340u6ke3sgcag">Contact</h2>
          <address className="mt-4 space-y-3 text-[15px] not-italic text-afb-muted" data-id="element-130" data-mp="382ffjod7c6fd">
            <p data-id="element-131" data-mp="2u2wj3str6jiw">
              {contact.street}
              <br data-id="element-132" data-mp="2u24mqfsc0hrk" />
              {contact.locality} {contact.region} {contact.postcode}
              <br data-id="element-133" data-mp="2z0y3ch2x0ovy" />
              {contact.country}
            </p>
            <p data-id="element-134" data-mp="1io0v3g97v5po">
              <a href={contact.phoneHref} className="transition-colors duration-150 hover:text-afb-ink" data-id="element-135" data-mp="1in7ukx0upcfz">
                {contact.phoneDisplay}
              </a>
            </p>
            <p data-id="element-136" data-mp="13kpxlo9ia63c">
              <a href={contact.emailHref} className="transition-colors duration-150 hover:text-afb-ink" data-id="element-137" data-mp="13l950b1j5c34">
                {contact.email}
              </a>
            </p>
          </address>
        </div>

        <div data-id="element-138" data-mp="urw8kz49bsca">
          <h2 className="font-sora text-sm font-semibold text-afb-ink" data-id="element-139" data-mp="ure1t8jyxvq4">Follow</h2>
          <div className="mt-4 flex gap-3" data-id="element-140" data-mp="ptukfzrz52ty">
            <a href={socialLinks.linkedin} aria-label="Australian Flow Batteries on LinkedIn" className="flex h-11 w-11 items-center justify-center rounded-btn border border-afb-line bg-white text-afb-ink transition-colors duration-150 hover:border-afb-ink/40" data-id="element-141" data-mp="pt2scyxl5n8f">
              <LinkedinIcon aria-hidden="true" className="h-5 w-5" data-id="element-142" data-mp="bvehmjx8fwh3" />
            </a>
            <a href={socialLinks.youtube} aria-label="Australian Flow Batteries on YouTube" className="flex h-11 w-11 items-center justify-center rounded-btn border border-afb-line bg-white text-afb-ink transition-colors duration-150 hover:border-afb-ink/40" data-id="element-143" data-mp="6wbej50tc0br">
              <YoutubeIcon aria-hidden="true" className="h-5 w-5" data-id="element-144" data-mp="28q6bysi89z5a" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-afb-line" data-id="element-145" data-mp="2ii29a1chpl8g">
        <div className="mx-auto flex max-w-page flex-col gap-3 px-5 py-6 text-sm text-afb-muted md:flex-row md:items-center md:justify-between lg:px-8" data-id="element-146" data-mp="2iilvvvd34xst">
          <p data-id="element-147" data-mp="1ptocfox50uyh">© {new Date().getFullYear()} Australian Flow Batteries</p>
          <p data-id="element-148" data-mp="1pvhmle6ylxb8">Product images are illustrative renders, not photos of AFB projects.</p>
          <a href={contact.privacyUrl} className="transition-colors duration-150 hover:text-afb-ink" data-id="element-149" data-mp="1uuc329hgf9s6">
            Privacy policy
          </a>
        </div>
      </div>
    </footer>;
}